import React from 'react';
import universal from 'react-universal-component';

const options = {
  ignoreBabelRename: true,
  loadingTransition: false,
  render: (props, Component) => {
    if (Component) {
      return (<Component {...props} />);
    }
    return (<svg height="56" viewBox="0 0 176 56" width="176" xmlns="http://www.w3.org/2000/svg" {...props} />);
  },
};

export const CarTakeBackLogo = universal(() => import(/* webpackChunkName: 'CarTakeBackLogo' */ './CarTakeBackLogo'), options);
